import i18n from 'i18next';
import {showNotification} from 'platform/components';

import type {EagColumn} from '../types/EagColumn';
import type {RowData} from '../types/RowData';
import {buildClipboardTsv, ClipboardCopyMode} from './buildClipboardTsv';

/**
 * Serializes rows to TSV and writes them to the system clipboard.
 * On failure (permissions / insecure context) shows an error notification; never throws.
 */
export async function copyRowsToClipboard(
  rows: RowData[],
  columns: EagColumn[],
  mode: ClipboardCopyMode
): Promise<void> {
  const tsv = buildClipboardTsv(rows, columns, mode);
  try {
    await navigator.clipboard.writeText(tsv);
  } catch {
    showNotification.error(
      i18n.t('page.datagrid.contextMenu.copyFailed', {defaultValue: 'Copy to clipboard failed'})
    );
  }
}
